<div class="gesuch-modul">
    <h1 class="access-for-all-title" translate>AFA_GESUCHSFORMULAR</h1>
    <div class="row view-title">
        <div class="col-md-12">
            <h2>
                <span
                    translate
                    [translateParams]="{gesuchsteller: '', basisjahr: ''}"
                    >FINANZIELLE_SITUATION</span
                >
            </h2>
            <hr class="header" />
        </div>
    </div>

    @if (
        !hasMultipleGS ||
        !dvShowWarningAngabenVervollstaendigenService.showWarningAngabenVervollstaendigen()
    ) {
        <ng-container [ngTemplateOutlet]="allGSAusgefuellt"></ng-container>
    } @else {
        <ng-container [ngTemplateOutlet]="notAllGSAusgefuellt"></ng-container>
    }
</div>

<ng-template #allGSAusgefuellt>
    <form #form="ngForm" class="gesuch">
        <dv-auszahlungsdaten
            [auszahlungsdaten]="model.zahlungsinformationen"
            [auszahlungsdatenGS]="model.zahlungsinformationenGS"
            [showAddress]="true"
        >
        </dv-auszahlungsdaten>

        @if (hasMultipleGS) {
            <dv-steuerveranlagung-gemeinsam
                [model]="model"
                (gemeinsamChanged)="this.gemeinsamChanged($event)"
            ></dv-steuerveranlagung-gemeinsam>
            @if (model.familienSituation.gemeinsameSteuererklaerung) {
                <dv-steuerveranlagt-schwyz
                    [finSitJA]="
                        model.getFiSiConToWorkWith().finanzielleSituationJA
                    "
                    [finSitGS]="
                        model.getFiSiConToWorkWith().finanzielleSituationGS
                    "
                    [readonly]="gesuchModelManager.isGesuchReadonly()"
                    [schwyzErweiterteFinSit]="
                        isSchwyzFinSitTypSchwyzErweitert()
                    "
                    (valueChanged)="recalculateMassgendesEinkommen()"
                >
                </dv-steuerveranlagt-schwyz>
            }
            @if (model.familienSituation.gemeinsameSteuererklaerung) {
                <div class="row margin-bottom-20">
                    <div class="col-sm-6">
                        <dv-input-label-field
                            [model]="resultate?.massgebendesEinkVorAbzFamGr"
                            [labelMessageKey]="
                                'FINANZIELLE_SITUATION_MASSGEBENDES_EINKOMMEN'
                            "
                            [inputDisabled]="true"
                        >
                        </dv-input-label-field>
                    </div>
                </div>
            }
        } @else {
            <dv-finanzielle-situation-single-gs-schwyz
                [readonly]="gesuchModelManager.isGesuchReadonly()"
                (valueChanged)="recalculateMassgendesEinkommen()"
                [finanzModel]="model"
                [schwyzErweiterteFinSit]="isSchwyzFinSitTypSchwyzErweitert()"
            >
            </dv-finanzielle-situation-single-gs-schwyz>
            @if (
                isNotNullOrUndefined(
                    getModel().finanzielleSituationJA.quellenbesteuert
                )
            ) {
                <div class="row margin-bottom-20">
                    <div class="col-sm-6">
                        <dv-input-label-field
                            [model]="resultate?.massgebendesEinkVorAbzFamGr"
                            [labelMessageKey]="
                                'FINANZIELLE_SITUATION_MASSGEBENDES_EINKOMMEN'
                            "
                            [inputDisabled]="true"
                        >
                        </dv-input-label-field>
                    </div>
                </div>
            }
        }
    </form>

    <dv-navigation-x
        (dvSave)="prepareSave($event.onResult)"
        [canGoNext]="true"
        [canGoPrevious]="true"
        [dvSubStep]="getSubStepIndex()"
        [dvSubStepName]="getSubStepName()"
    ></dv-navigation-x>
</ng-template>

<ng-template #notAllGSAusgefuellt>
    <div data-test="warnung-gs2-ausfuellen" class="well well-status-warten">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span translate>WARNUNG_GS2_AUSFUELLEN</span>
    </div>
</ng-template>
